import { gql } from '@apollo/client';

export const ENABLE_PURCHASE_CHAPTER_DTO = gql`
  fragment EnablePurchaseChapterDto on Story {
    enabledPurchasedChapter {
      chapterCount
      coinAmount
      hasAdultChapter
    }
  }
`;

export const WEB_NOVEL_LAST_PLAY_INFO_DTO = gql`
  fragment WebNovelLastPlayInfoDto on Story {
    lastPlay {
      currentPlayingChapter {
        chapter {
          ...WebNovelChapterDto
        }
      }
    }
  }
`;
